import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

export enum Theme {
  Tech = 'tech', // 科技风
  Business = 'business', // 商务风
  Classic = 'classic' // 经典风
}

type ThemeContextValue = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

const ThemeContext = createContext<ThemeContextValue | null>(null);

// 工具函数：把主题应用到页面
function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export function ThemeProvider({
  children,
  defaultTheme = Theme.Tech
}: {
  children: React.ReactNode;
  defaultTheme?: Theme;
}) {
  const [theme, setThemeState] = useState<Theme>(defaultTheme);

  useEffect(() => {
    setThemeState(defaultTheme);
    applyTheme(defaultTheme);
  }, [defaultTheme]);

  const setTheme = useCallback((theme: Theme) => {
    setThemeState(theme);
    applyTheme(theme);
  }, []);

  const value = useMemo(() => ({
    theme,
    setTheme
  }), [theme, setTheme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

// 任何组件都能拿主题
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}